import { render } from "./CalculatorBranch.vue?vue&type=template&id=3fff9635&ts=true"
import script from "./CalculatorBranch.vue?vue&type=script&lang=ts"
export * from "./CalculatorBranch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__